import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const AthletesInfoRow = styled.div.attrs({ className: "flex items-center gap-3" })``;

export const AthletesThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const AthletesLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const AthletesMetaText = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const AthletesGridLayout = styled.div.attrs({
  className: "grid gap-3 md:grid-cols-[1.4fr_0.8fr_0.8fr]",
})``;

export const AthletesFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const AthletesFieldSelect = styled.select.attrs({ className: "brand-input" })``;

export const AthletesPrimaryButton = styled.button.attrs({
  className: "brand-button inline-flex items-center gap-2",
})``;
